import React from "react";

const faq5 = () =>{
  return(
    <>
      <p>
        Genom att trycka på respektive knapp och 
        jämföra hur det påverkar din månadslön, 
        eller annat nyckeltal du bevakar.
      </p>
      <p>
        Du kan byta bolagsform så ofta du önskar 
        och jämföra effekten på valfria nyckeltal.
      </p>
    
    </>
  );
}
export default faq5;